import classNames from 'classnames';

import Typography, { TypographyProps } from '../typography/typography';

export interface EmptyPlaceholderProps {
  className?: string;
  fullWidth?: boolean;
  TypographyProps?: TypographyProps;
  variant?: 'default' | 'dark';
}

/**
 * Placeholder for empty content (e.g. empty list)
 */
export function EmptyPlaceholder({
  children,
  className,
  fullWidth = true,
  variant = 'default',
  TypographyProps,
}: React.PropsWithChildren<EmptyPlaceholderProps>) {
  return (
    <div
      className={classNames(
        'px-6 py-4 border border-solid text-center rounded-lg font-medium text-sm',
        variant === 'default' && 'border-border bg-surface-base text-brand-primary',
        variant === 'dark' && 'border-gray-700 bg-gray-700 text-zinc-200',
        fullWidth ? 'w-full' : undefined,
        className,
      )}
    >
      <Typography variant="none" {...TypographyProps} className={classNames(TypographyProps?.className)}>
        {children}
      </Typography>
    </div>
  );
}

export default EmptyPlaceholder;
